/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useNavigate, useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'

// MUI
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import GroupIcon from '@mui/icons-material/Group'
import BarChartIcon from '@mui/icons-material/BarChart'
import PieChartOutlineIcon from '@mui/icons-material/PieChartOutline'
import PieChartIcon from '@mui/icons-material/PieChart'
import CategoryIcon from '@mui/icons-material/Category'
import AssignmentIcon from '@mui/icons-material/Assignment'
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd'
import PersonIcon from '@mui/icons-material/Person'
import RecentActorsIcon from '@mui/icons-material/RecentActors'
import LibraryAddIcon from '@mui/icons-material/LibraryAdd'
import LayersIcon from '@mui/icons-material/Layers'

// Helper methods
import { dashboardNavbarHeight, positionChangeWidthSm, swipelyticsTurquoise, swipelyticsPink } from '../../helpers/variableDefaults'

import useWindowDimensions from '../../helpers/windowDimensions'

// The navbar appears at the top of the website on all pages except for unwrap views
const NavDashboard  = (props) => {

  const { isDemo, userId, viewIndex, userIsReviewer, setViewIndex, setLoading } = props

  // Navigate
  const navigate = useNavigate()

  // Payload
  // const payload = getPayload()

  // URL Path
  const urlPath = window.location.pathname

  // Dynamic Window Dimensions
  const { height, width } = useWindowDimensions()

  // Params
  // const { userId } = useParams()

  // States

  const handleNavProfiles = async (event) => {
    // setLoading(true)
    setViewIndex(0)
    // setLoading(false)

  }

  const handleNavNewRequests = async (event) => {
    // setLoading(true)
    setViewIndex(0)
    // setLoading(false)

  }

  const handleNavMedia = async (event) => {
    // setLoading(true)
    setViewIndex(1)
    // setLoading(false)
  }

  const handleNavHistory = async (event) => {
    // setLoading(true)
    setViewIndex(1)
    // setLoading(false)
  }

  const handleNavBio = async (event) => {
    // setLoading(true)
    setViewIndex(2)
    // setLoading(false)
  }

  const handleNavReviewerBio = async (event) => {
    // setLoading(true)
    setViewIndex(2)
    // setLoading(false)
  }

  return (
    <>
      <AppBar position="static" component="nav"
        style={{ 
          backgroundColor: 'lightgray',
          boxShadow: 'none', 
        }}
      >
        <Toolbar 
          sx={{ 
            width: '100%',
            height: dashboardNavbarHeight,
            fontFamily: 'Lato',
            display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: !userIsReviewer ? 'space-around' : 'space-around', 
          }}
        >

          {/* For Businesses and Schools — Contains a 'Customize' Section */}
          {!userIsReviewer && ['Profile', 'Media', 'Bio'].map((text, index) => (
            <Box key={text} 
              sx={{
                // backgroundColor: 'orange',
                width: width >= positionChangeWidthSm ? '150px' : '60px',
                display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: !userIsReviewer ? 'space-around' : 'space-around',
              }}
            >
              
              {/* {width < positionChangeWidthSm ? */}
              {width < 300 ?
                // Icon Button if smaller screen width
                <Box
                  sx={{
                    // backgroundColor: 'orange',
                  }}    
                >
                  <IconButton
                    size="large"
                    aria-label="inside account navigation"
                    aria-haspopup="true"
                    onClick={index === 0 ? handleNavProfiles : index === 1 ? handleNavMedia : handleNavBio}
                    color="inherit"
                  >
                    {index === 0 ? <BarChartIcon sx={{ color: viewIndex === 0 ? swipelyticsPink : 'black' }}/> : index === 1 ? <CategoryIcon sx={{ color: viewIndex === 1 ? swipelyticsPink : 'black' }}/> : <PersonIcon sx={{ color: viewIndex === 2 ? swipelyticsPink : 'black' }}/> }
                  </IconButton>
                </Box>
                :
                // Words if larger screen width
                <Box
                  onClick={index === 0 ? handleNavProfiles : index === 1 ? handleNavMedia : handleNavBio}
                  sx={{
                    cursor: 'pointer',
                    color: (index === 0 && viewIndex === 0) || (index === 1 && viewIndex === 1) || (index === 2 && viewIndex === 2) ? swipelyticsPink : 'black',
                    fontWeight: 'bold',
                  }}
                >
                  {text}
                </Box>
              }
              
            </Box>
          ))}

          {/* For Individuals — No 'Customize' Section */}
          {userIsReviewer && ['New Requests', 'History', 'Bio'].map((text, index) => (
            <Box key={text} 
              sx={{
                // backgroundColor: 'orange',
                width: width >= positionChangeWidthSm ? '150px' : '60px',
                display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: !userIsReviewer ? 'space-around' : 'space-around',
              }}
            >
              
              {/* {width < positionChangeWidthSm ? */}
              {width < 300 ?
                // Icon Button if smaller screen width
                <Box
                  sx={{
                    // backgroundColor: 'orange',
                  }}    
                >
                  <IconButton
                    size="large"
                    aria-label="inside account navigation"
                    aria-haspopup="true"
                    onClick={index === 0 ? handleNavNewRequests : index === 1 ? handleNavHistory : handleNavReviewerBio}
                    color="inherit"
                  >
                    {index === 0 ? <LibraryAddIcon sx={{ color: viewIndex === 0 ? swipelyticsPink : 'black' }}/> : index === 1 ? <LayersIcon sx={{ color: viewIndex === 1 ? swipelyticsPink : 'black' }}/> : <PersonIcon sx={{ color: viewIndex === 2 ? swipelyticsPink : 'black' }}/> }
                  </IconButton>
                </Box>
                :
                // Words if larger screen width
                <Box
                  onClick={index === 0 ? handleNavNewRequests : index === 1 ? handleNavHistory : handleNavReviewerBio}
                  sx={{
                    cursor: 'pointer',
                    color: (index === 0 && viewIndex === 0) || (index === 1 && viewIndex === 1) || (index === 2 && viewIndex === 2) ? swipelyticsPink : 'black',
                    fontWeight: 'bold',
                  }}
                >
                  {text}
                </Box>
              }
              
            </Box>
          ))}
          
        </Toolbar>
      </AppBar>
    </>
  )
}

export default NavDashboard